import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { CustomSelection, Report, SelectionAction } from '../../../report/report';
import { BankAccountsActionsService } from './bank-accounts-requests-actions.service';
import { BankAccountsRequestsService } from './bank-accounts-requests.service';

@Component({
  selector: 'app-bank-accounts',
  templateUrl: './bank-accounts.component.html',
  styleUrls: ['./bank-accounts.component.scss']
})
export class BankAccountsComponent implements OnInit {

  tableColumns: string[] = [
    "accountNumber",
    "type",
    "holderName",
    "status",
    "createdAt",
    "branchName",
    "bankName",
    "businessName",
    "amount"
  ];

  displayTableColumns = {
    'businessName': 'Business Name',
    'type': 'Account Type',
    'holderName': 'Holder Name',
    'accountNumber': 'Account Number',
    'branchName': 'Branch Name',
    'bankName': 'Bank Name',
    'createdAt': 'Created At',
    'status': 'Status',
    "amount": "Amount"
  };
  totalNumberOfRecords = 0;
  bankAccountsData: any;
  selectionModel = new SelectionModel<any>(true, []);
  filterField = [
    {
      filterFieldName: 'status',
      filterDisplayName: 'Status',
      defaultValue: 'Pending',
      filterOptions: [
        { key: 'Show All', value: null },
        { key: 'Accepted', value: 'Accepted' },
        { key: 'Pending', value: 'Pending' },
        { key: 'Rejected', value: 'Rejected' },
      ]
    }
  ];

  selectionActions: SelectionAction[] = [
    {
      actionName: "Accept",
      actionValue: "Accepted",
      actionType: "Button",
      actionClass: "btn-success"
    },
    {
      actionName: "Reject",
      actionValue: "Rejected",
      actionType: "Button",
      actionClass: "btn-outline-danger"
    }
  ];

  requestBody: Report = {};
  loading = false;

  selectableRows: Array<CustomSelection> = [
    {
      colName: "status",
      valueIn: ["Pending"]
    }
  ];

  async selectionActionsCB(event: any) {
    let selectedRequests: any[] = event.selection;
    this.bankAccountsAction.setParams({ selectedRequests, status: event.action })
    await this.bankAccountsAction.make();
    this.updateTable();

  }

  constructor(
    public bankAccountsService: BankAccountsRequestsService,
    private bankAccountsAction: BankAccountsActionsService
  ) { }

  ngOnInit() {
    this.bankAccountsService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.requestBody.filterOptions = { status: 'Pending' };
    this.updateTable();
  }


  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      delete this.requestBody.filterOptions;
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.bankAccountsService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.bankAccountsService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.bankAccountsService.loader().subscribe(val => (this.loading = val));
  }


  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.bankAccountsService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.bankAccountsService.activateLoader();
    this.bankAccountsService.setParams(this.requestBody);
    const report = await this.bankAccountsService.make();
    report.result.forEach((r: any) => {
      r.createdAt = moment(r.createdAt).format('LL');
    });
    this.bankAccountsData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

}
